// extracted by mini-css-extract-plugin
export default {"advertCard":"c-a_hc","advertCardNum":"c-a_he"};